module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "weui-progress"
  }, [_c('div', {
    staticClass: "weui-progress__bar"
  }, [_c('div', {
    staticClass: "weui-progress__inner-bar js_progress vw-progress",
    style: (_vm.styleObj)
  })]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('a', {
    staticClass: "weui-progress__opr",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "weui-icon-cancel"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-47dcb138!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/progress/progress.vue
// module id = 238
// module chunks = 0